import classNames from 'classnames/bind';
import styles from './HelpJuiceFaqs.module.scss';
import { FaqQuestions } from './FaqQuestions/FaqQuestions';
import { FaqAnswer } from './FaqAnswer/FaqAnswer';
import { FaqBreadcrumbs } from './FaqBreadcrumbs/FaqBreadcrumbs';
import { FaqSidebar } from './FaqSidebar/FaqSidebar';
import { useRouter } from 'next/compat/router';

let cx = classNames.bind(styles);

export function HelpJuiceFaqs({ data, router }) {
	let { questions, answer, relatedQuestions, mainCategories } = data;
  const basePath = '/help/faqs';
  const pathname = useRouter().asPath.split(/[?#]/)[0];

	return (
		<div className={cx(['content'])}>
			<div className={cx(['grid-left'])}>
				<FaqSidebar basePath={basePath} mainCategories={mainCategories} />
			</div>
			<div className={cx(['grid-right'])}>
				{path !== basePath && <FaqBreadcrumbs router={router} basePath={basePath} categories={mainCategories.categories} />}
				{questions && <FaqQuestions title={data.name || 'Search Results'} questions={questions} query={data.query} pagePath={pathname !== basePath ? pathname : `${basePath}/${data.id}`} basePath={basePath} />}
				{answer && <FaqAnswer title={data.text} answer={answer} id={data.id} relatedQuestions={relatedQuestions} basePath={basePath} />}
			</div>
		</div>
	);
}
